import * as Yup from 'yup';

export const newUserSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().required('Email is required').email('Email must be a valid email address'),
  phone: Yup.string().required('Phone number is required'),
  rol: Yup.string().required('Role is required'),
  password: Yup.string().min(6, 'Need more that 6 characters').required('Password is required'),
  indicatorPhone: Yup.string().required('Ingrese un indicativo de telefono'),
  branch: Yup.boolean().default(true).optional(),
});

export const editUserSchema = Yup.object().shape({
  name: Yup.string().optional(),
  email: Yup.string().optional(),
  phone: Yup.string().optional(),
  rol: Yup.string().optional(),
  password: Yup.string().optional(),
  indicatorPhone: Yup.string().optional(),
    branch: Yup.boolean().optional().default(true)
});
